import React, { useEffect, useRef, useState } from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import { Box, Typography, useTheme } from "@mui/material";
import checkinbanner from "../../../../media/images/checkin-banner.png";
import profileImage from "../../../../media/images/profileImage.png";
import bigCar2 from "../../../../media/images/icons/bigcar2.svg";
import InfoCircle from "../../../../media/images/icons/info-circle";
import PlusMini from "../../../../media/images/icons/plus-mini";
import EditIcon from "../../../../media/images/icons/edit-icon";
import { Link } from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import BottomTabbar from "../../../layout/DriverLayout/BottomTabbar";
import CarTagView from "../../../components/CarTag";
export default function CheckInPage() {
  const divRef = useRef<HTMLDivElement>(null);

  const theme = useTheme();

  const [hasScroll, setHasScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 600,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            اعلام حضور{" "}
          </Typography>
        }
        hasScroll={hasScroll}
      />

      <Box
        ref={divRef}
        sx={{
          flex: "1",
          overflowY: "auto",
          paddingX: "16px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            borderRadius: "16px",
            backgroundColor: "primary.main",
            overflow: "hidden",
            display: "flex",
          }}
        >
          <Box
            sx={{
              width: "100px",
              backgroundImage: `url(${checkinbanner})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "150px",
              backgroundPosition: "center",
              transform: "rotate(-15deg)",
            }}
          ></Box>
          <Box
            sx={{
              flex: 1,
              paddingY: "8px",
              paddingX: "4px",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              //   border: "1px solid gray",
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontWeight: "600",
              }}
            >
              اعلام حضور
            </Typography>
            <Box
              sx={{
                borderRadius: "10px",
                backgroundColor: "primary.light",
                display: "flex",
                gap: "3px",
                padding: "3px",
              }}
            >
              <InfoCircle color={theme.palette.primary.main} />
              <Typography
                sx={{
                  fontWeight: "600",

                  fontSize: "12px",
                  color: "primary.main",
                }}
              >
                برای دریافت بار از بازارگاه نیاز است تا حضور خود را با مشخصات
                وسیله نقلیه‌تان(ناوگان) در منطقه نزدیک ایستگاه اعلام کنید.
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            marginTop: "8px",
            backgroundColor: "background.default",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            padding: "8px",
            borderStyle: "solid",
            borderColor: "info.main",
            borderWidth: "1px",
            borderRadius: "8px",
          }}
        >
          <Box
            sx={{
              //   border: "1px solid gray",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img
                style={{
                  width: "32px",
                  borderRadius: "50%",
                }}
                src={profileImage}
                alt=""
              />
              <Typography
                sx={{
                  color: "secondary.main",
                  fontWeight: "600",
                }}
              >
                رضا یعقوبی‌فریان پور
              </Typography>
            </Box>
            <CarTagView />
          </Box>

          <Box
            sx={{
              borderColor: "info.main",
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              backgroundColor: "info.light",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={bigCar2} alt="" />
              <Typography
                sx={{
                  fontWeight: "600",
                }}
              >
                نوع بارگیر:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "secondary.main",
                fontWeight: "600",
              }}
            >
              خاور مسقف 6 چرخ 7 تا 10 تن{" "}
            </Typography>
          </Box>
          <Box
            sx={{
              borderColor: "info.main",
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              backgroundColor: "info.light",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={bigCar2} alt="" />
              <Typography
                sx={{
                  fontWeight: "600",
                }}
              >
                گروه بارگیر:{" "}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <Typography
                sx={{
                  color: "secondary.main",
                  fontWeight: "600",
                }}
              >
                مسقف یا چادری خاور{" "}
              </Typography>
              <Link
                to={"#"}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                  padding: "4px",
                  borderRadius: "4px",
                  backgroundColor: theme.palette.primary.main,
                }}
              >
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "12px",
                  }}
                >
                  تغییر گروه
                </Typography>
                <EditIcon size={18} />
              </Link>
            </Box>
          </Box>
          <Box
            sx={{
              borderColor: "info.main",
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              backgroundColor: "info.light",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={bigCar2} alt="" />
              <Typography
                sx={{
                  fontWeight: "600",
                }}
              >
                نام سالن:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "secondary.main",
                fontWeight: "600",
              }}
            >
              اسم سالن در این قسمت{" "}
            </Typography>
          </Box>
          <CustomButton
            flexDirection="row-reverse"
            //   onClick={() => appDispatch(changeLoginType())}
            title="آماده دریافت بار هستم"
            bgColor="primary.main"
            width="100%"
            fSize="16px"
            fontWeight={600}
            px="10px"
            py="12px"
            borderRadius="10px"
            color="lightStatic.main"
            icon1={<PlusMini size={32} />}
          />
          <Typography
            sx={{
              fontWeight: "600",
              textAlign: "center",
            }}
          >
            با اعلام حضور، شما یک نوبت در بین دیگر رانندگان بر اساس زمانی که
            اعلام حضور می‌کنید دریافت خواهید کرد
          </Typography>
        </Box>
      </Box>
      <BottomTabbar />
    </>
  );
}
